import { useAuth } from './context/AuthContext';
import { useMail } from './context/MailContext';
import Login from './components/Auth/Login';
import Topbar from './components/Layout/Topbar';
import Sidebar from './components/Layout/Sidebar';
import EmailList from './components/Mail/EmailList';
import EmailView from './components/Mail/EmailView';
import ComposeModal from './components/Compose/ComposeModal';
import SettingsPanel from './components/Settings/Settings';
import './App.css';

const SETTINGS_PANES = ['autoresponder', 'signature', 'settings'];

function MailApp() {
  const { activeFolder } = useMail();
  const isSettingsPane = SETTINGS_PANES.includes(activeFolder);

  return (
    <div className="app-shell">
      <Topbar />
      <div className="app-body">
        <Sidebar />
        <EmailList />
        {isSettingsPane ? <SettingsPanel /> : <EmailView />}
      </div>
      <ComposeModal />
    </div>
  );
}

export default function App() {
  const { user } = useAuth();
  return user ? <MailApp /> : <Login />;
}
